<ng-lottie width="310px" [style]="'margin: 0 auto;display: inline-block;'" [options]="options"></ng-lottie>
